import { type FC } from "react";
import { Icons, SymbolIcon } from "widgets";

import type { ProjectFile } from "@/graphql.ts";
import { FILE_BROWSE_TYPES } from "@/settings/settings.ts";
import { FileIcon } from "@/ui-modules/core/FileIcon.tsx";

interface HeaderIconProps {
  file: Pick<ProjectFile, "fileName" | "fileBrowseType">;
}

export const HeaderIcon: FC<HeaderIconProps> = ({ file }) =>
  file?.fileBrowseType === FILE_BROWSE_TYPES.DIRECTORY ? (
    <img src={Icons.Tiles.FileBrowser} height={30} width={24} alt={"file-browser-icon"} />
  ) : file?.fileBrowseType === FILE_BROWSE_TYPES.HYPERLINK ? (
    <SymbolIcon icon={"link"} />
  ) : (
    <FileIcon filename={file?.fileName} key={"file-icon"} />
  );
